import { OrderRouteItem, schOrderRouteItem } from '@aloft/toolkit-shared';
import { Flex, Icon, Menu, MenuButton, MenuItem, MenuList, Typography } from '@aloft/toolkit-sui';

import { NavLink } from 'react-router-dom';

import { selectIsInspectifyOrder } from '../../../redux/features/selectors/orderSelectors.ts';
import { selectDeviceWidth } from '../../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { menuListProps, menuProps } from '../consts.ts';
import { HeaderDesktopSubNavByProductType } from './HeaderDesktopSubNavByProductType.tsx';
import { HeaderDesktopTopNav } from './HeaderDesktopTopNav.tsx';
import { HeaderDesktopTopNavLegacy } from './HeaderDesktopTopNavLegacy.tsx';
import { HeaderMobileSubNav } from './HeaderMobileSubNav.tsx';
import { DESKTOP_TOP_NAV_GROUPS, craftsmanUIHeaderNavItems } from './constants.ts';
import { NavItemType, SubNavItemType, groupNavItems, hasSubnav } from './types.ts';
import { useCurrentNavItem } from './useCurrentNavItem.ts';

const getRoute = (item: NavItemType) =>
  hasSubnav(item) ? `${item.route}/${(item.subnav[0] as SubNavItemType).route}` : item.route;

export const HeaderNav = () => {
  const deviceWidth = useAppSelector(selectDeviceWidth);
  const isInspectifyOrder = useAppSelector(selectIsInspectifyOrder);
  const headerNavItems = craftsmanUIHeaderNavItems;
  const shouldUseLegacy = !isInspectifyOrder;

  const currentNavItem = headerNavItems[useCurrentNavItem() ?? 'paired-cost'];

  const orderRouteItems = schOrderRouteItem.options;
  const visibleOrderRouteItems = orderRouteItems.filter((itemName) =>
    DESKTOP_TOP_NAV_GROUPS.some((group) => group.routes.includes(itemName)),
  );
  const groupedDesktopTopNavItems = groupNavItems(
    visibleOrderRouteItems.map((itemName) => ({
      route: itemName,
      item: headerNavItems[itemName],
    })),
    DESKTOP_TOP_NAV_GROUPS,
  );

  return (
    <Flex flexDirection="column" position="relative" alignSelf="center">
      {deviceWidth === 'phone' ? (
        <>
          <div className="main-header-nav-mobile">
            <Menu {...menuProps}>
              <MenuButton>
                <Flex gap=".25rem" alignItems="center" marginTop=".375rem">
                  <Typography variant="h4">{currentNavItem.label}</Typography>
                  <Icon icon="arrow-down-s" size="lg" color="textPrimary" />
                </Flex>
              </MenuButton>
              <MenuList {...menuListProps}>
                {(shouldUseLegacy ? orderRouteItems : visibleOrderRouteItems).map(
                  (itemName: OrderRouteItem) => {
                    const item = headerNavItems[itemName];

                    return (
                      <NavLink key={`header-nav-${item.route}`} to={getRoute(item)}>
                        <MenuItem>
                          <Typography variant="body1">{item.label}</Typography>
                        </MenuItem>
                      </NavLink>
                    );
                  },
                )}
              </MenuList>
            </Menu>
          </div>
          <HeaderMobileSubNav />
        </>
      ) : (
        <>
          {shouldUseLegacy ? (
            <HeaderDesktopTopNavLegacy
              orderRouteItems={orderRouteItems}
              headerNavItems={headerNavItems}
              getRoute={getRoute}
            />
          ) : (
            <HeaderDesktopTopNav groupedDesktopTopNavItems={groupedDesktopTopNavItems} getRoute={getRoute} />
          )}
          <HeaderDesktopSubNavByProductType />
        </>
      )}
    </Flex>
  );
};
